














































































































/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FormHtmlEditor from '@/components/shared/FormHtmlEditor.vue';
import FormNumberInput from '@/components/shared/FormNumberInput.vue';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import LayerConfig from '@/models/map-context/LayerConfig';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

@Component({
  props: {
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
    FormNumberInput,
    FormHtmlEditor
  },
})
export default class SingleLayerAttributeInfos extends BaseComponent {
  layer!: LayerConfig;

  errorTxt: string | null = null;

  selectAll = false;

  guessMode = false;

  public attributeTypes = [{ value: 'xsd:int', label: 'Entier' },
    { value: 'xsd:string', label: 'Texte' },
    { value: 'xsd:number', label: 'Nombre' },
    { value: 'xsd:boolean', label: 'Booléen' },
    { value: 'xsd:double', label: 'Double' },
  ];

  editorLoaded = false;

  properties:any=[];

  mounted() {
    if (this.layer.layerProperties.length === 0 && this.layer.isVector()) {
      // No properties, try to guess from datas
      this.guessMode = true;
      const features = this.layer.getLayerSource().getFeatures();
      console.log(features[0]);
      if (features && features.length > 0) {
        if (this.is3DView()) {
          features[0].properties.propertyNames.forEach((element: any) => {
            this.layer.layerProperties.push(new LayerAttribute({
              name: element,
              type: 'xsd:string',
              editable: true,
              display: true,
            }));
          });
        } else {
          features[0].getKeys().forEach((element: any) => {
            this.layer.layerProperties.push(new LayerAttribute({
              name: element,
              type: 'xsd:string',
              editable: true,
              display: true,
            }));
          });
        }
      }
    }
    this.properties=this.layer.layerProperties;
    if (this.layer.ficheInfos.active) {
      this.editorLoaded = true;
    }
  }


  onChangeFicheInfoType() {
    if (this.layer.ficheInfos.active && (this.layer.ficheInfos.content === '' || this.layer.ficheInfos.content === undefined)) {
      this.initFicheContent();
    }
    this.editorLoaded = true;
  }

  initFicheContent() {
    this.layer.ficheInfos.content = '';
    if (this.layer.layerProperties) {
      for (let i = 0; i < this.layer.layerProperties.length; i += 1) {
        this.layer.ficheInfos.content += `<p>${this.layer.layerProperties[i].name}:{${this.layer.layerProperties[i].name}}</p>`;
      }
    }
  }

  isAttributeEditable() {
    return (this.layer.editable || this.guessMode) && this.contextService.isEditionActive;
  }

  getFieldType(value: string) {
    if (value.indexOf('xsd:') >= 0) {
      return value.split(':')[1];
    }
    return value;
  }

  reloadAttributes() {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm('Etes-vous sur de vouloir rechargez la définition des attributs depuis le serveur?')) {
      this.getMapService().setAttributeDefinition(this.layer, true);
      setTimeout(()=>{
        this.properties=this.layer.layerProperties;
        },3000);
    }
  }

  addAttribute() {
    this.layer.layerProperties.push(new LayerAttribute({
      name: `nouveau_${this.layer.layerProperties.length}`,
      type: 'xsd:string',
      editable: true,
      display: true,
    }));
    this.properties=this.layer.layerProperties;
  }
}
